module.exports = __webpack_public_path__ + "static/media/GPG601A_F01_EV.28ed012b.jpg";